<template lang="pug">
  .generic-section
    v-row(
      v-if="cards.length"
      no-gutters
    )
      v-col(cols=12)
        draggable.justify-center(
          v-model="cards"
          :disabled="readonly"
          tag="v-slide-y-reverse-transition"
          class="row"
          :component-data="{props}"
        )

          v-col(
            v-for="(card, idx) in cards"
            :key="card.hash"
            v-bind="cardColumnConfig"
          )
            C-card(
              v-model="cards[idx]"
              :type="card.type"
              :last="cards.length - 1 === idx"
              :readonly="readonly"
              @add:before="createCard(idx)"
              @add:after="createCard(idx + 1)"
              @remove="removeCard(idx)"
            )
</template>

<script>
import ConstructorCard from '@/models/list/ConstructorCard';
import draggable from 'vuedraggable';

import CCard from './CCard.vue';
import { CARD_TYPES } from './constants';

export default {
  components: {
    draggable,
    CCard,
  },
  props: {
    // Array of Cards
    cardsValues: { type: Array, default: null },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      props: {
        group: true,
        'leave-absolute': true,
      },
    };
  },
  computed: {
    cards: {
      get() {
        return this.cardsValues;
      },
      set(value) {
        this.$emit('update:cards', value);
      },
    },
    cardColumnConfig() {
      const [card] = this.cards;
      const CONFIG_BY_TYPE = {
        [CARD_TYPES.topAvatarShadow]: { cols: 12, md: 4, lg: 3 },
        [CARD_TYPES.leftAvatar]: { cols: 12, md: 8 },
        [CARD_TYPES.question]: { cols: 12, md: 8 },
        [CARD_TYPES.progress]: { cols: 12, md: 4, lg: 3 },
      };
      return CONFIG_BY_TYPE[card.type];
    },
  },
  methods: {
    createCard(positionIdx) {
      const [card] = this.cards;
      this.cards.splice(positionIdx, 0, new ConstructorCard({
        type: card.type,
      }));
    },
    removeCard(positionIdx) {
      this.cards.splice(positionIdx, 1);
    },
  },
};
</script>
